import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as Icons from "react-feather";
import { useAuth } from "store/auth";
import { useCore } from "store/core";
import { toJalali } from "lib/helpers";
import Modal from "components/Modal";
import moment from "moment-jalaali";
import { Field, Form, Formik } from "formik";
import { dateTimeToserver, toDatePicker } from "lib/helpers";
import { Select, Loading } from "components/form";
import { PersianDataPicker } from "components/form";
export default function DirectorReport(props) {
  const auth = useAuth();
  const core = useCore();
  const [screeningDetail, setScreeningDetail] = useState(null);
  const [showScreeningDetail, setShowScreeningDetail] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    core.dispatch(
      core.getDirectorDashboard(props.user_id, (data) => {
        setData(data);
      })
    );
  }, []);
  return (
    <>
      <ShowScreeingDetail
        show={showScreeningDetail}
        close={() => {
          setShowScreeningDetail(false);
        }}
        items={screeningDetail}
      />
      <div className="col-span-12 mt-8">
        <div className="intro-y flex items-center justify-between h-20">
          <h2 className="text-lg font-medium truncate mr-5">
            گزارش کلی فروش محصولات شما در vod
          </h2>
          <Formik
            initialValues={{
              from:
                data && data.filters.from
                  ? toDatePicker(data && data.filters.from)
                  : null,
              to:
                data && data.filters.to
                  ? toDatePicker(data && data.filters.to)
                  : null,
            }}
            onSubmit={async (values, { setSubmitting }) => {
              core.dispatch(
                core.getDirectorDashboard(
                  props.user_id,
                  (data) => {
                    setData(data);
                  },
                  values.from
                    ? dateTimeToserver(values.from, "YYYY-MM-DD")
                    : null,
                  values.to ? dateTimeToserver(values.to, "YYYY-MM-DD") : null
                )
              );
            }}
            enableReinitialize
          >
            {({ isSubmitting, dirty, values }) => (
              <Form>
                <div className="flex mt-5 gap-x-1 justify-end">
                  <Field
                    label="از تاریخ"
                    name="from"
                    disable_today={true}
                    component={PersianDataPicker}
                  />
                  <Field
                    label="تا تاریخ"
                    name="to"
                    disable_today={true}
                    component={PersianDataPicker}
                  />
                  <button
                    className="btn btn-primary w-36 h-12 mt-6"
                    type="submit"
                    disabled={!!(isSubmitting || !dirty)}
                  >
                    {" "}
                    {isSubmitting ? <Loading /> : "اعمال"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="grid grid-cols-12 gap-6 mt-5"></div>
      </div>
      <div className="box col-span-12 overflow-auto lg:overflow-visible">
        <div className="flex justify-between">
          {" "}
          <h2 className="m-2"> گزارش فروش اکران ها</h2>
          <button
            className="btn btn-primary w-12 h-6 m-2"
            onClick={() => {
              core.dispatch(
                core.getDirectorReportScreening(
                  props.user_id,
                  () => {},
                  (data && data.filters.from) || null,
                  (data && data.filters.to) || null
                )
              );
            }}
          >
            Excel
          </button>
        </div>
        <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
          <table className="table table-report -mt-2">
            <thead>
              <tr>
                <th className="whitespace-nowrap text-center">شناسه</th>
                <th className="whitespace-nowrap text-center">عنوان محصول</th>
                <th className="whitespace-nowrap text-center">
                  تعداد کل فروش بلیت
                </th>
                <th className="whitespace-nowrap text-center">
                  سهم شما(تومان)
                </th>
                <th className="whitespace-nowrap text-center">سهم شما(دلار)</th>
                <th className="whitespace-nowrap text-center">
                  تاریخ ایجاد محصول
                </th>
                <th className="whitespace-nowrap text-center">مشاهده جزییات</th>
              </tr>
            </thead>

            <tbody>
              {data &&
                data.screening_products &&
                data.screening_products.length > 0 &&
                data.screening_products.map((item) => (
                  <tr className="intro-x">
                    <td className="w-16 text-center">{item.id}</td>
                    <td>
                      <div className="flex justify-center">
                        {item.detail.title}
                      </div>
                    </td>
                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {item.total_sold_ticket_count}
                      </p>
                    </td>
                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {item.total_irr_amount}
                      </p>
                    </td>
                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {item.total_usd_amount}
                      </p>
                    </td>

                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {" "}
                        {toJalali(item.created_at, "jYYYY-jMM-jDD")}
                      </p>
                    </td>
                    <td>
                      <div className="flex justify-center items-center">
                        <a
                          className="flex items-center ml-3 cursor-pointer"
                          onClick={() => {
                            setScreeningDetail(item.sold_details);
                            setShowScreeningDetail(true);
                          }}
                        >
                          {" "}
                          <Icons.Eye className="w-4 h-4 ml-1" /> مشاهده جزییات
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="box col-span-12 overflow-auto lg:overflow-visible">
        <div className="flex justify-between">
          <h2 className="m-2"> گزارش فیلم ها</h2>
          <button
            className="btn btn-primary w-12 h-6 m-2"
            onClick={() => {
              core.dispatch(
                core.getDirectorReportMovies(
                  props.user_id,
                  () => {},
                  (data && data.filters.from) || null,
                  (data && data.filters.to) || null
                )
              );
            }}
          >
            Excel
          </button>
        </div>
        <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
          <table className="table table-report -mt-2">
            <thead>
              <tr>
                <th className="whitespace-nowrap text-center">شناسه</th>
                <th className="whitespace-nowrap text-center">عنوان محصول</th>
                <th className="whitespace-nowrap text-center">تعداد مشاهده</th>
                <th className="whitespace-nowrap text-center">سهم شما(درصد)</th>
                <th className="whitespace-nowrap text-center">قیمت پایه</th>
                <th className="whitespace-nowrap text-center">مبلغ</th>
                <th className="whitespace-nowrap text-center">
                  تاریخ ثبت محصول
                </th>
              </tr>
            </thead>

            <tbody>
              {data &&
                data.vod_products &&
                data.vod_products.length > 0 &&
                data.vod_products.map((item) => (
                  <tr className="intro-x">
                    <td className="w-16 text-center">{item.id}</td>
                    <td>
                      <div className="flex justify-center">
                        {item.detail.title}
                      </div>
                    </td>
                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {item.sold_count}
                      </p>
                    </td>
                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {item.owner_percent}
                      </p>
                    </td>
                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {item.price}
                      </p>
                    </td>
                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {item.total_amount}
                      </p>
                    </td>

                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {" "}
                        {toJalali(item.created_at, "jYYYY-jMM-jDD")}
                      </p>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="box col-span-12 overflow-auto lg:overflow-visible">
        <div className="flex justify-between">
          <h2 className="m-2"> گزارش فروش فیلم ها (تکی)</h2>{" "}
          <button
            className="btn btn-primary w-12 h-6 m-2"
            onClick={() => {
              core.dispatch(
                core.getDirectorReportSingle(
                  props.user_id,
                  () => {},
                  (data && data.filters.from) || null,
                  (data && data.filters.to) || null
                )
              );
            }}
          >
            Excel
          </button>
        </div>
        <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
          <table className="table table-report -mt-2">
            <thead>
              <tr>
                <th className="whitespace-nowrap text-center">شناسه</th>
                <th className="whitespace-nowrap text-center">عنوان محصول</th>
                <th className="whitespace-nowrap text-center">تعداد فروش</th>
                <th className="whitespace-nowrap text-center">سهم شما(درصد)</th>
                <th className="whitespace-nowrap text-center">قیمت پایه</th>
                <th className="whitespace-nowrap text-center">مبلغ فروش</th>
                <th className="whitespace-nowrap text-center">
                  تاریخ ثبت محصول
                </th>
              </tr>
            </thead>

            <tbody>
              {data &&
                data.single_products &&
                data.single_products.length > 0 &&
                data.single_products.map((item) => (
                  <tr className="intro-x">
                    <td className="w-16 text-center">{item.id}</td>
                    <td>
                      <div className="flex justify-center">
                        {item.detail.title}
                      </div>
                    </td>
                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {item.sold_count}
                      </p>
                    </td>
                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {item.owner_percent}
                      </p>
                    </td>
                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {item.price}
                      </p>
                    </td>
                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {item.total_amount}
                      </p>
                    </td>

                    <td>
                      <p className="font-medium whitespace-nowrap text-center">
                        {" "}
                        {toJalali(item.created_at, "jYYYY-jMM-jDD")}
                      </p>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export function ShowScreeingDetail(props) {
  const { show } = props;
  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <div class="mt-3 text-center sm:mt-0 sm:mr-4 sm:text-right">
          <div className="box col-span-12 overflow-auto lg:overflow-visible">
            <h2 className="m-2">جزییات فروش اکران</h2>
            <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
              <table className="table table-report -mt-2">
                <thead>
                  <tr>
                    <th className="whitespace-nowrap text-center">فروشنده</th>
                    <th className="whitespace-nowrap text-center">
                      تعداد فروش
                    </th>
                    <th className="whitespace-nowrap text-center">
                      سهم شما(درصد)
                    </th>
                    <th className="whitespace-nowrap text-center">قیمت پایه</th>
                    <th className="whitespace-nowrap text-center">مبلغ فروش</th>
                  </tr>
                </thead>

                <tbody>
                  {props.items &&
                    props.items.length > 0 &&
                    props.items.map((item) => (
                      <tr className="intro-x">
                        <td>
                          <div className="flex justify-center">{item.tag}</div>
                        </td>
                        <td>
                          <p className="font-medium whitespace-nowrap text-center">
                            {item.count}
                          </p>
                        </td>
                        <td>
                          <p className="font-medium whitespace-nowrap text-center">
                            {item.owner_percent}
                          </p>
                        </td>
                        <td>
                          <p className="font-medium whitespace-nowrap text-center">
                            {item.unit + " " + item.currency_name}
                          </p>
                        </td>
                        <td>
                          <p className="font-medium whitespace-nowrap text-center">
                            {item.total_amount + " " + item.currency_name}
                          </p>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse dark:bg-[#313a55]">
            <button
              type="button"
              disabled={props.load}
              onClick={props.close}
              className="btn btn-outline-secondary w-20 mr-1"
            >
              بستن
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
